'use client'
import ContactCard from '@/app/components/contact-card'
import Link from 'next/link'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleNav } from '../app-store/navSlice'
import { RootState } from '../interfaces/appInterface'
import Image from 'next/image'
import logoBrand from '../../img/brand.svg'

export default function Faq() {
  const isNavOpen = useSelector((state: RootState) => state.nav.isNavOpen)
  const dispatch = useDispatch()

  const showNav = () => {
    dispatch(toggleNav())
  }
  const faq = [
    {
      question: 'What information do I need to provide for payroll processing?',
      answer:
        "To process payroll, you'll need to provide employee details, including names, addresses, tax information, salary or wage details, and any other relevant compensation or deduction information. A sample CSV file can be downloaded from the application. All you need to do is to fill it according to the format provided and upload."
    },
    {
      question: 'Can I raise invoices to my clients on the app?',
      answer:
        'Yes, you can raise invoices, track the status of invoices, and mail them to your clients for payment.'
    },
    {
      question: 'Do I need approval for bulk transfers or payroll processing?',
      answer:
        'Depending on your role, you may need approval from an authorized person before submitting bulk transfers or processing payroll.'
    },
    {
      question: 'What security measures are in place to prevent fraud?',
      answer:
        'We implement robust security measures, including user verification, transaction monitoring, encryption, and multi-factor authentication, to protect your data and prevent fraudulent activities.'
    },
    {
      question: 'Are there any fees associated with using your services?',
      answer:
        'Yes, our services include fees. Fees for payroll processing, single transfers, and bulk transfers will be clearly disclosed before you complete a transaction.'
    },
    {
      question:
        'Can I track the status of my transfers and payroll processing?',
      answer:
        'Yes, you can track the status of your transfers and payroll processing in real-time and through your transaction history.'
    },
    {
      question: 'What happens if a transfer fails?',
      answer:
        'If a transfer fails, you will be notified immediately. You may be asked to review and correct any issues, such as incorrect recipient details, and then resubmit the transfer.'
    },
    {
      question: 'How do I update my account information?',
      answer:
        'You can update your account information, such as contact details or banking information, directly through your account settings. If you need assistance, our customer support team is available to help.'
    }
  ]

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <Image
              src={logoBrand}
              className="navbar-brand-img"
              alt="kegow brand"
              width={150}
              height={70}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded={isNavOpen ? 'true' : 'false'}
            aria-label="Toggle navigation"
            onClick={showNav}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${
              isNavOpen ? 'show overflow-y-auto' : ''
            }`}
            id="navbarCollapse"
          >
            <button
              className="navbar-toggler text-primary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              onClick={showNav}
            >
              <span className="fs-2" aria-hidden="true">
                &times;
              </span>
            </button>

            <ul className="navbar-nav ms-auto">
              <li className="nav-item border-top-0">
                <a className="nav-link" href="/faq">
                  FAQ
                </a>
              </li>
            </ul>

            <Link
              prefetch
              className="navbar-btn btn btn-sm btn-primary lift ms-auto"
              href="/signup"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </nav>
      <div className="container">
        <section
          className="custom-block custom-block-faq bg-white"
          id="welcome"
        >
          <div className="title-group mb-3">
            <h1 className="h2 mb-0">How can we help?</h1>
          </div>

          <div className="row my-4">
            <div className="col-lg-7 col-12">
              <div className="custom-block custom-block-faq">
                <h5 className="mb-4">Frequently Asked Questions</h5>

                {faq.map((item, index) => (
                  <div key={index}>
                    <strong className="d-block mb-2">{item.question}</strong>
                    <p>{item.answer}</p>
                    <br />
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-5 col-12">
              <ContactCard />
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
